// extracted by mini-css-extract-plugin
export default {"main":"Hierarchy_main__CTVEz","hierarchy":"Hierarchy_hierarchy__fRNXC"};